export default __webpack_public_path__ + "static/media/bottom-social-overlay.623f9a6b.svg";